// ------------- Hooks -------------
export {
  useAvailableSpaces,
  useCurrentSpace,
  useIsSpaceHydrated,
  useSetAvailableSpaces,
  useSetCurrentSpace,
  useSpaceContext,
  useSpaceId,
} from './hooks';

// ------------- Provider -------------
export { SpaceStoreProvider, useSpaceStore, useSpaceStoreApi } from './provider';

// ------------- Store -------------
export { createSpaceStore, type SpaceStoreApi } from './store';

// ------------- Types -------------
export type {
  SpaceActions,
  SpaceState,
  SpaceStore,
  SpaceStoreInitProps,
  UseCurrentSpaceResult,
} from './types';
